module.exports = __webpack_public_path__ + "assets/img/gqlcs.055a341e.png";